"use client";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import {
  protocol1,
  protocol2,
  protocol3,
  protocol4,
  protocol5,
  protocol6,
} from "@/images/index";
import { useEffect, useState } from "react";

const Fetures = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const staggerChildren = {
    animate: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  if (!mounted) {
    return null; // or a loading state
  }
  return (
    <div className="relative pt-20">
      {/* Mission Section */}
      <section className="py-20 px-4 ">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                OUR MISSION
              </motion.div>

              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                TO TRANSFORM CRYPTO&apos;S COMPLEXITY AND DECENTRALIZE
                OPPORTUNITIES
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                You can be part of it. Any BLOK holders have the ability to
                participate in all aspects of the protocol.
              </motion.p>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol1}
                alt="Our Mission"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>
      {/* ERC 4337 Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-purple-900/20 to-transparent">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                POWERED BY ERC 4337
              </motion.div>
              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                A new horizon for Blockchain innovation
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                BLOK Capital is pioneering the use of ERC-4337, a revolutionary
                technology that makes your investments safer. Your funds really
                stay with you and only you have full access to them.
              </motion.p>
              <motion.ul variants={fadeIn} className="space-y-4 mt-6">
                <li className="flex items-center gap-3 text-gray-600">
                  <span className="w-2 h-2 bg-purple-400 rounded-full" />
                  Account abstraction
                </li>
                <li className="flex items-center gap-3 text-gray-600">
                  <span className="w-2 h-2 bg-purple-400 rounded-full" />
                  Easy social login
                </li>
                <li className="flex items-center gap-3 text-gray-600">
                  <span className="w-2 h-2 bg-purple-400 rounded-full" />
                  Co-authored by Vitalik Buterin
                </li>
                <li className="flex items-center gap-3 text-gray-600">
                  <span className="w-2 h-2 bg-purple-400 rounded-full" />A new
                  horizon for Blockchain innovation
                </li>
              </motion.ul>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol2}
                alt="ERC 4337"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Self Custody Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                SELF-CUSTODY
              </motion.div>
              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                KEEP CONTROL OF YOUR ASSETS WITH SELF CUSTODY
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                At BLOK Capital, we instill complete confidence in our investors
                by placing the power of self-custody directly in their hands.
              </motion.p>
              <motion.p variants={fadeIn} className="text-gray-600">
                With self-custody, investors eliminate the need to transfer
                funds to external parties, your assets remain securely on-chain
                within your personal wallet.
              </motion.p>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol3}
                alt="Self Custody"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* SECURITY */}
      <section className="py-20 px-4 bg-gradient-to-b from-purple-900/20 to-transparent">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                SECURITY
              </motion.div>
              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                SECURITY IS OUR TOP-PRIORITY
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                The protocol boasts enhanced security, incorporating elements
                such as multi-factor authentication, permission controls, and a
                fraud monitoring protocol that simulates transactions before
                execution.
              </motion.p>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol4}
                alt="Garden Ecosystem"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/*  GARDEN ECOSYSTEM */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                GARDEN ECOSYSTEM
              </motion.div>
              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                GROW YOUR GARDEN WITH THE BEST GARDENERS
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                At BLOK Capital, we refer to Investment Portfolios held in your
                wallet as Gardens – and Expert Portfolio Managers as Gardeners.
              </motion.p>
              <motion.p variants={fadeIn} className="text-gray-600">
                With the best Gardeners, you can invest like a pro in a few easy
                steps. You maintain full control of your assets while the
                experts handle your investments.
              </motion.p>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol5}
                alt="Garden Ecosystem"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* TRANSPARENCY */}
      <section className="py-20 px-4 bg-gradient-to-b from-purple-900/20 to-transparent">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div className="space-y-6">
              <motion.div
                variants={fadeIn}
                className="inline-block px-4 py-2 bg-white border-2 border-gray-300 text-gray-800 rounded-full text-sm font-semibold shadow-md hover:bg-gray-100 transition-all duration-300 ease-in-out"
              >
                TRANSPARENCY
              </motion.div>
              <motion.h3
                variants={fadeIn}
                className="text-3xl md:text-4xl text-black font-bold"
              >
                TRANSPARENCY IN EVERY STEP AND NO SURPRISES
              </motion.h3>
              <motion.p variants={fadeIn} className="text-gray-600">
                Our DAO offers complete transparency on every decision we make,
                while investors maintain full custody of their crypto assets.
              </motion.p>
            </div>
            <motion.div
              variants={fadeIn}
              className="relative aspect-square rounded-2xl overflow-hidden  p-1"
            >
              <div className="absolute inset-0 " />
              <Image
                src={protocol6}
                alt="Transparency"
                width={800}
                height={800}
                className="w-full h-full object-cover rounded-2xl transform  transition-transform duration-500"
                quality={90}
              />
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Fetures;
